import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';
import { useLanguage } from '../../context/language';

const StyledContactSection = styled.section`
  max-width: 660px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 16px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(38px, 5vw, 58px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 46px;
  }
`;

const Contact = () => {
  const { content } = useLanguage();
  const contact = content.contact;
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, [prefersReducedMotion]);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">{contact.overline}</h2>

      <h2 className="title">{contact.title}</h2>

      <p>{contact.description}</p>

      <a className="email-link" href={`mailto:${email}`}>
        {contact.cta}
      </a>
    </StyledContactSection>
  );
};

export default Contact;
